/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLineAxis: {
  name: 'line-axis';
  data: string;
} = {
  name: 'line-axis',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 4a1 1 0 1 0-2 0v15a2 2 0 0 0 2 2h15a1 1 0 1 0 0-2H5v-5.533l3.308-2.764 2.925 2.445a2 2 0 0 0 2.771-.198l4.74-5.282a1 1 0 0 0-1.488-1.336l-4.74 5.282L9.59 9.169a2 2 0 0 0-2.565 0L5 10.86V4Z" fill="currentColor"/></svg>`,
};
